/**
 * Get the display URL for an asset.
 * If data looks like a URL (starts with / or http), use it directly.
 * Otherwise assume it's base64 and build a data URI.
 */
export function getAssetSrc(data: string, mimeType: string): string {
    if (data.startsWith('/') || data.startsWith('http')) {
        return data;
    }
    if (data.startsWith('data:')) {
        return data;
    }
    return `data:${mimeType};base64,${data}`;
}
